import React, { useContext, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import TitleNavBarContext from 'context/TitleNavBarContext';
import { UseTranslationProps } from 'types/UseTranslationProps';

export default function Showcase() {
	const { i18n }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({ ...value, title: 'Vitrine dinâmica' }));
	}, [i18n?.language]);

	return (
		<S.container>
			<h1>Showcase</h1>
		</S.container>
	);
}
